// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Nv0Z","rightAdornment":"Header_rightAdornment__2hhlU"};